export const ModalChangePhoneNumberTranslationsUk = {
  changePhoneNumber: 'Змінити номер телефону',
  phoneNumber: 'Номер телефону',
  saveButton: 'Зберегти',
};
